import React from 'react';

import CommonImage from '@/components/CommonImage';

const Send3dModal = () => {
	return (
		<div className="popup-wrapper">
			<div className="common-popup update-task-modal">
				<div className="common-popup-header d-flex justify-content-between">
					<div className="popup-tilte">
						<h3 className="semibold-16 mb-0">Update task</h3>
					</div>
					<div className="close-btn">
						<CommonImage alt="close" src="/icons/close.svg" />
					</div>
				</div>
				<div className="common-popup-body">
					<div className="row">
						<div className="col-md-12">
							<div className="form-group">
								<label htmlFor="collection">Required date *</label>
								<input type="date" />
							</div>
						</div>
					</div>
					<div className="send-pd-table">
						<table className="table with-border">
							<thead>
								<tr>
									<th class="design-details-column">
										<span class="ml-2">Design(1)</span>
									</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>
										<div className="d-flex align-items-center">
											<img
												src="https://d2939dhdpmjcbe.cloudfront.net/product/reference_image/2025/6/394/1749981041084_Screenshot_2025-03-10_at_10.00.45%E2%80%AFAM.png"
												alt="image"
												className="cell-img"
											/>
											<div className="ml-2">
												<span className="status set">Set</span>
												{/* <span className="status pack">Pack</span> */}
												<p className="regular-12 gray_dark_01 py-1">MT25-A0187 </p>
												<ul className="common-list-component mb-2">
													<li>Men</li>
													<li>SWEATSHIRT</li>
												</ul>
											</div>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div className="modal-footer">
					<div className="footer-buttons text-right">
						<button className="button size32 ml-2">Submit</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Send3dModal;
